import { type ReactElement } from 'react';
import { NeonButtonFooter, NeonModalDialog } from '@ps-refarch-ux/neon';
import type { SubjectArea } from '@/types';
import { NEON_TEXT, NeonButtonTypes } from '@/constants/neon-constants';
import { paragraphStyle } from './subject-areas.styles';

type DeleteSubjectAreaDialogProps = {
  isOpen: boolean;
  subjectAreaToDelete: SubjectArea | null;
  isDeleting: boolean;
  onDelete: () => void;
  onClose: () => void;
};

export const DeleteSubjectAreaDialog = ({
  isOpen,
  subjectAreaToDelete,
  isDeleting,
  onDelete,
  onClose,
}: DeleteSubjectAreaDialogProps): ReactElement | null => {
  if (!isOpen || !subjectAreaToDelete) {
    return null;
  }

  return (
    <NeonModalDialog id="delete-subject-area-modal" neonDialogHasClosed={onClose} dataSize="small">
      <div data-slot="dialog-header-title">Delete {subjectAreaToDelete.name}</div>
      <div data-slot="dialog-body">
        <p className={NEON_TEXT} style={paragraphStyle('14px', '20px', false)}>
          Are you sure you want to delete this subject area?
        </p>
      </div>
      <div data-slot="dialog-button-footer">
        <NeonButtonFooter
          id="delete-subject-area-modal-button-footer"
          buttons={[
            {
              id: 'delete-subject-area-modal-cancel',
              text: 'Cancel',
              type: NeonButtonTypes.Borderless,
              onClick: (event): void => {
                event.target?.dispatchEvent(new Event('neonDialogClose', { bubbles: true }));
              },
            },
          ]}
          primaryButton={{
            id: 'delete-subject-area-modal-delete',
            text: 'Delete',
            type: NeonButtonTypes.Tertiary,
            disabled: isDeleting,
            onClick: (): void => {
              onDelete();
            },
          }}
        />
      </div>
    </NeonModalDialog>
  );
};
